import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LoginPage.css";
import ugaaLogo from "../../Assets/images/logo-rmbg.png"; 
import alumniGroup from "../../Assets/images/about-image.jpg"; 
import { FaEye, FaEyeSlash } from "react-icons/fa";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, { email, password });
      const { token, user } = response.data;

      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(user));

      // Redirect based on systemRole
      if (user.systemRole === "ADMIN" || user.systemRole === "SYSTEM ADMIN") {
        navigate("/admin-panel");
      } else {
        navigate("/"); // fallback
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    alert("Please contact the SYSTEM ADMIN to reset your password.");
  };

  return (
    <div
      className="login-page"
      style={{ backgroundImage: `url(${alumniGroup})` }}
    >
      {/* Overlay */}
      <div className="login-overlay"></div>

      {/* Centered login form */}
      <div className="login-form-wrapper">
        <div className="login-card">
          <div className="login-header">
            <img src={ugaaLogo} alt="UGAA Logo" className="login-logo" />
            <h1>Admin Panel</h1>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {error && <p className="login-error">{error}</p>}

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group password-group">
              <label>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <div className="forgot-password" onClick={handleForgotPassword}>
              Forgot Password?
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
